import axios from '@/axios';
import router from '@/routes/router';
import swal from 'sweetalert2';

const state = {
    engines: {
        docs: []
    },
    loading: false, 
    engine: null,
    attachmentLoading: false,
};

const actions = {
    async getAll({ commit,dispatch }, siteId, options) {
        commit('getAllRequest');
        try{
            const opt = {
                page: 1,
                limit: 20,
                ...options
            }
            const res = await axios.get(`/api/sites/${siteId}/engines?page=${opt.page}&limit=${opt.limit}`)
            commit('getAllSuccess', res.data);
        } catch(e){
            commit('getAllFailure', e);
            dispatch('alert/error', e, { root: true });
        };
    },

    async get({ commit,dispatch }, {id}) {
        commit('getRequest');
        return new Promise( async (resolve,reject) => {
            try{
                const res = await axios.get(`/api/engines/${id}`)
                commit('getSuccess', res.data);
                resolve(res.data)
            } catch(e){
                commit('getFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e)
            };
        })
    },

    async update({ commit,dispatch }, engine) {
        commit('updateRequest', engine);
        try{
            const res = await axios.put(`/api/sites/${engine.site}/engines/${engine.id}`,{engine})
            commit('updateSuccess', res.data);
            dispatch('alert/success', 'Motore modificato correttamente', { root: true });
        } catch(e){
            commit('updateFailure', e);
            dispatch('alert/error', e, { root: true });
        };
    },

    async create({ commit,dispatch }, {siteId, engine}) {
        commit('createRequest', engine);
        try{
            const res = await axios.post(`/api/sites/${siteId}/engines`,{engine})
            commit('createSuccess', res.data);
            dispatch('alert/success', 'Motore creato correttamente', { root: true });
            setTimeout(() => {router.push(`/sites/${siteId}/engines/${res.data.id}`) },500);
        } catch(e){
            commit('createFailure', e);
            dispatch('alert/error', e, { root: true });
        };
    },

    delete({ commit,dispatch }, {siteId, id}) {
        return new Promise(async (resolve,reject) => {
            const confirm = await swal.fire({
                title: 'Sicuro?',
                // text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Elimina elemento',
                cancelButtonText: 'Annulla',
                reverseButtons: true
            })
    
            if (confirm.value) {
                commit('deleteRequest', id);
                try{
                    const data = await axios.delete(`/api/sites/${siteId}/engines/${id}`)
                    dispatch('alert/success', 'Motore rimosso correttamente', { root: true });
                    commit('deleteSuccess', id);
                    swal.fire(
                        'Eliminato!',
                        'Il motore è stato cancellato.',
                        'success'
                    )
                    resolve(true)
                } catch(e){
                    commit('deleteFailure', e);
                    dispatch('alert/error', e, { root: true });
                    reject(e)
                };
            }
            // else if ( confirm.dismiss === 'cancel') {}
    
        })
    },

    async addAttachment({ commit, dispatch },{engineId,attachment}) {
        commit('addAttachmentRequest');
        const formData = new FormData();
        formData.append("attachment", attachment);

        try{
            const res = await axios.post(`/api/engines/${engineId}/engine-attachments`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            dispatch('alert/success', 'File caricato correttamente', { root: true });
            commit('addAttachmentSuccess', res.data);
        } catch(e){
            commit('addAttachmentFailure', e);
            dispatch('alert/error', e, { root: true });
            
        };        
    },


    async updateAttachment({ commit, dispatch },{engineId, id, engineAttachment}) {
        commit('updateAttachmentRequest');
        try{
            const res = await axios.put(`/api/engines/${engineId}/engine-attachments/${id}`,
                {engineAttachment})
            dispatch('alert/success', 'File modificato correttamente', { root: true });
            commit('updateAttachmentSuccess', res.data);
        } catch(e){
            commit('updateAttachmentFailure', e);
            dispatch('alert/error', e, { root: true });
        };        
    },

    async deleteAttachment({ commit, dispatch },{engineId,id}) {

        const confirm = await swal.fire({
            title: 'Sicuro?',
            // text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Elimina elemento',
            cancelButtonText: 'Annulla',
            reverseButtons: true
        })

        if (confirm.value) {
            commit('removeAttachmentRequest');
            try{
                const data = await axios.delete(`/api/engines/${engineId}/engine-attachments/${id}`)
                dispatch('alert/success', 'Motore rimosso correttamente', { root: true });
                commit('removeAttachmentSuccess', id);
            } catch(e){
                commit('removeAttachmentFailure', e);
                dispatch('alert/error', e, { root: true });
                
            };
        }
    }
};

const mutations = {
    getAllRequest(state) {
        state.loading = true;
        state.engines = [];
    },
    getAllSuccess(state, engines) {
        state.engines = engines;
        state.loading = false;
    },
    getAllFailure(state, error) {
        state.error = error;
        state.loading = false;
    },
    updateRequest(state, engine) {
        state.engine = {
            ...engine,
            loading: true
        };
    },
    updateSuccess(state, newEngine) {
        state.engines.docs = state.engines.docs.map(engine => (engine.id === newEngine.id ? newEngine : engine))
        state.engine = newEngine;
    },
    updateFailure(state, error) {        
        state.engine = { ...state.engine, error };
    },
    deleteRequest(state, id) {
        state.engines.docs = state.engines.docs.map(engine =>
            engine.id === id
                ? { ...engine, deleting: true }
                : engine
        )
    },
    deleteSuccess(state, id) {
        // remove deleted engine from state
        state.engines.docs = state.engines.docs.filter(engine => engine.id !== id)
    },
    deleteFailure(state, { id, error }) {
        // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
        state.engines.docs = state.engines.docs.map(engine => {
            if (engine.id === id) {
                // make copy of engine without 'deleting:true' property
                const { deleting, ...engineCopy } = engine;
                // return copy of engine with 'deleteError:[error]' property
                return { ...engineCopy, deleteError: error };
            }

            return engine;
        })
    },
    createRequest(state) {
        state.loading = true;
    },
    createSuccess(state, engine) {
        state.loading = false;
        state.engine = engine;
    },
    createFailure(state, e) {
        state.loading= false;
    },
    getRequest(state) {
        state.loading = true;
    },
    getSuccess(state, engine) {
        state.loading = false;
        state.engine = engine;
    },
    getFailure(state) {
        state.loading = false;
    },
    addAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    addAttachmentSuccess(state,attachment) {
        state.attachmentLoading = false;
        state.engine.attachments.push(attachment);
    },
    addAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
    updateAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    updateAttachmentSuccess(state) {
        state.attachmentLoading = false;
    },
    updateAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
    removeAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    removeAttachmentSuccess(state,attachmentId) {
        state.attachmentLoading = false;
        state.engine.attachments = state.engine.attachments.filter(att => att.id !== attachmentId)
    },
    removeAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
};

export const engines = {
    namespaced: true,
    state,
    actions,
    mutations
};